import React from 'react';
import type { PermKey, Perm } from '@/modes/common/gql';
import usePerms from '@/hooks/usePerms';

type RequirePermsProps = {
  children: React.ReactNode;
} & Partial<Record<PermKey, Perm | Perm[]>>;

export default function RequirePerms({
  children,
  ...permProps
}: RequirePermsProps) {
  const perms = usePerms();
  const entries = Object.entries(permProps) as [PermKey, Perm | Perm[]][];
  const hasAllPerms =
    entries.length > 0 &&
    entries.every(([key, perm]) =>
      typeof perm === 'string'
        ? perms[key]?.includes(perm)
        : perm.every((p) => perms[key]?.includes(p))
    );
  return hasAllPerms ? <>{children}</> : <></>;
}
